// Focus element
// https://medium.com/hackernoon/removing-that-ugly-focus-ring-and-keeping-it-too-6c8727fefcd2
function handleFirstTab(e) {
    if (e.keyCode === 9) { // the "I am a keyboard user" key
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
    }
}
window.addEventListener('keydown', handleFirstTab);

const INTERACTIVE_SELECTOR = [
    "a[href]",
    "button",
    "input:not([type='hidden'])",
    "select",
    "textarea",
    "[contenteditable='true']",
    "summary"
  ].join(",");

const accessibilityHelpers = {
    getFocusableElement: function getFocusableElement(container, position = "last") {
        if (!container) return null;

        const selector = `
            a[href],
            button:not([disabled]),
            input:not([disabled]):not([type="hidden"]),
            select:not([disabled]),
            textarea:not([disabled]),
            [tabindex]:not([tabindex="-1"]),
            [contenteditable="true"]
        `;

        let focusables = Array.from(container.querySelectorAll(selector));

        // Filter out non-visible or disabled elements
        focusables = focusables.filter(el => {
            const style = window.getComputedStyle(el);
            const isVisible =
            style.visibility !== "hidden" &&
            style.display !== "none";

            return isVisible && !el.hasAttribute("disabled") && el.tabIndex !== -1;
        });

        if (focusables.length === 0) return null;

        return position === "first"
            ? focusables[0]
            : focusables[focusables.length - 1];
    },

    setSlideA11yState(swiper) {
        if (!swiper || !swiper.slides) return;

        // Determine which slides are "visible" in Swiper's terms
        // Swiper marks visible slides with .swiper-slide-visible (when watchSlidesProgress = true)
        // We fall back to active slide if that class isn't present.
        const slides = Array.from(swiper.slides);

        const hasVisibleClass = slides.some(s => s.classList.contains("swiper-slide-visible"));

        slides.forEach((slide) => {
        const isVisible = hasVisibleClass
            ? slide.classList.contains("swiper-slide-visible")
            : slide.classList.contains("swiper-slide-active");

        // 1) Screen reader visibility
        slide.setAttribute("aria-hidden", String(!isVisible));

        // 2) Disable/enable interactive elements
        const interactiveEls = Array.from(slide.querySelectorAll(INTERACTIVE_SELECTOR));

        interactiveEls.forEach((el) => {
            // if (!isTrulyFocusable(el)) return;

            if (!isVisible) {
            // Store original tabindex once
            if (!el.hasAttribute("data-orig-tabindex")) {
                const orig = el.getAttribute("tabindex");
                el.setAttribute("data-orig-tabindex", orig === null ? "" : orig);
            }
            el.setAttribute("tabindex", "-1");
            } else {
            // Restore original tabindex
            if (el.hasAttribute("data-orig-tabindex")) {
                const orig = el.getAttribute("data-orig-tabindex");
                if (orig === "") el.removeAttribute("tabindex");
                else el.setAttribute("tabindex", orig);
                el.removeAttribute("data-orig-tabindex");
            } else {
                // If it was explicitly -1 in markup, leave it alone (we didn't set data attr)
            }
            }
        });
        });
    },

    bindA11yToSwiper(swiper) {
        // Important: visible slide class is most reliable when this is on
        // (if you can, set watchSlidesProgress: true in your Swiper config)
        this.setSlideA11yState(swiper);

        swiper.on("init", () => this.setSlideA11yState(swiper));
        swiper.on("slideChange", () => this.setSlideA11yState(swiper));
        swiper.on("transitionEnd", () => this.setSlideA11yState(swiper));
        swiper.on("resize", () => this.setSlideA11yState(swiper));
        swiper.on("observerUpdate", () => this.setSlideA11yState(swiper)); // if observer enabled
    }

}